/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, { FC, MouseEventHandler, useCallback } from "react";

type IProps = {
  label: string;
  value: any;
  error?: string;
  isEditing?: boolean;
  onClick?: MouseEventHandler<HTMLDivElement>;
  handler?: (val: any) => void;
} & Record<string, any>;

const OrderSpentHours: FC<IProps> = ({
  value,
  onClick,
}) => {
  return (
    <div onClick={onClick}>
      {value && value.spentHours ? (
        parseFloat(value.spentHours.toFixed(2)) || '0'
      ) : (
        <div>0</div>
      )}
    </div>
  );
};

export { OrderSpentHours };
